import React from 'react';
import { IBlockRegion } from '../utils';
import { CurrentUserPosition } from './styles';
import RankBadge from './RankBadge';

const LoggedUserPosition = ({ isRanked, region }: { isRanked: boolean; region: IBlockRegion; }) => {
  return (
    <CurrentUserPosition isRanked={isRanked} region={region}>
      {
        isRanked ? (
          <>
            <td>1</td>
            <td>
              <RankBadge rank="Gold_1" />
              {region === 'landingPageBlock' && 'Gold 1'}
            </td>
            <td>Player 1</td>
          </>
        ) : (
          <>
            <td>1</td>
            <td>Player 1</td>
            <td>100</td>
            <td>100</td>
            <td>100</td>
            <td>100</td>
          </>
        )
      }
    </CurrentUserPosition>
  );
};

export default LoggedUserPosition;
